import React from "react"
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";
import App from "./app"
import "antd/dist/reset.css";
import * as serviceWorker from "./serviceWorker"
import "./style/app.css";

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#F36C28",
        colorBgLayout: "#FFFDFA",
        colorText: "#000000",
        colorIconHover: "#F36C28",
        colorInputBg: "#f3f4f6", 
        colorInputPlaceholder: "#bcc1ca", 
        colorAlertBg: "#fbfcfc", 
        colorAlertBorder: "#dee1e6",
        
      },
      components: {
        Layout: {
          siderBg: "#FFFDFA"
        },
        Menu: {
          itemSelectedBg: "#F36C28",
          itemSelectedColor: "#fff",
          itemBg: "#FFFDFA"
        }
    },
  
  }}
  >

    <BrowserRouter>
      <App />
    </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);

// ReactDOM.render(<App />, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
